module.exports = __webpack_public_path__ + "img/246-d5b870.png";